import { h, Component } from "preact";
import Routes           from "../containers/Routes";
import config           from "../config.js";

export const APP_KEY = "shop";

export class Shared extends Component {
  render({ translation }) {
    return <Routes config={config} translation={translation} />;
  }
}
